export default __webpack_public_path__ + "static/media/cp_geo_uz.a1a8b587.svg";